// js/shared/reply-promise.js — the one reply promise a NEW INQUIRY hears.
// QUEUE ITEM KV (audit E-07, decision d21 c).
//
// KG stored the promise once in Settings › Business as
// `business.inquiry_response_time_{en,es}` ("James replies within one business
// day."), for people who are not clients yet. The public pages speak in James's
// first person, so they say the same promise as "I reply ...". This module is
// the ONE place those words live on the public side: the home page, the new
// client form, the card and /trainers import it rather than each pack typing
// its own (the site used to say "one business day", "1–2 business days" and
// "48 hours" on four pages). tests/unit/shared/kv-reply-promise.test.mjs holds
// it to the stored default, so the setting and the site cannot drift apart.

export const INQUIRY_REPLY = Object.freeze({
  en: 'I reply within one business day.',
  es: 'Le respondo dentro de un día hábil.',
});

// The stored setting's default, word for word (js/shared/settings-registry.js,
// migration 20261112000100). The third person is the admin's voice.
export const INQUIRY_REPLY_STORED = Object.freeze({
  en: 'James replies within one business day.',
  es: 'James responde en un día hábil.',
});

/** The promise for a language; anything not Spanish is English. */
export function inquiryReply(lang) {
  return String(lang || '').toLowerCase().startsWith('es') ? INQUIRY_REPLY.es : INQUIRY_REPLY.en;
}
